/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Svd_View_AllInputs */

const en_svd_view_all = /** @type {(inputs: Svd_View_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`view all ${i?.count} modules`)
};

const ar_svd_view_all = /** @type {(inputs: Svd_View_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`عرض كل ${i?.count} الوحدات`)
};

const bn_svd_view_all = /** @type {(inputs: Svd_View_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`সব ${i?.count}টি মডিউল দেখুন`)
};

const de_svd_view_all = /** @type {(inputs: Svd_View_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`alle ${i?.count} Module anzeigen`)
};

const es_svd_view_all = /** @type {(inputs: Svd_View_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ver todos los ${i?.count} módulos`)
};

const fr_svd_view_all = /** @type {(inputs: Svd_View_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`afficher tous les ${i?.count} modules`)
};

const pt_svd_view_all = /** @type {(inputs: Svd_View_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`visualizar todos os ${i?.count} módulos`)
};

const zh_svd_view_all = /** @type {(inputs: Svd_View_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`查看所有 ${i?.count} 个模块`)
};

const tr_svd_view_all = /** @type {(inputs: Svd_View_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`tüm ${i?.count} modülleri görüntüle`)
};

const ru_svd_view_all = /** @type {(inputs: Svd_View_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`просмотреть все модули: ${i?.count}`)
};

const pl_svd_view_all = /** @type {(inputs: Svd_View_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`wyświetl wszystkie moduły (${i?.count}).`)
};

/**
* | output |
* | --- |
* | "view all {count} modules" |
*
* @param {Svd_View_AllInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svd_view_all = /** @type {((inputs: Svd_View_AllInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svd_View_AllInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svd_view_all(inputs)
	if (locale === "bn") return bn_svd_view_all(inputs)
	if (locale === "de") return de_svd_view_all(inputs)
	if (locale === "es") return es_svd_view_all(inputs)
	if (locale === "fr") return fr_svd_view_all(inputs)
	if (locale === "pt") return pt_svd_view_all(inputs)
	if (locale === "zh") return zh_svd_view_all(inputs)
	if (locale === "tr") return tr_svd_view_all(inputs)
	if (locale === "ru") return ru_svd_view_all(inputs)
	if (locale === "pl") return pl_svd_view_all(inputs)
	return en_svd_view_all(inputs)
});